var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMonogram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#C2A15E",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 4.25,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 1.4,
    fill: "#C2A15E",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 1.5V7M14 21v5.5M1.5 14H7M21 14h5.5M5.16 5.16l3.9 3.9M18.94 18.94l3.9 3.9M22.84 5.16l-3.9 3.9M9.06 18.94l-3.9 3.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22 2.45l2.08 5.1M16.7 20.45l2.08 5.1M2.45 18.78l5.1-2.08M20.45 11.3l5.1-2.08M18.78 2.45l-2.08 5.1M11.3 20.45l-2.08 5.1M2.45 9.22l5.1 2.08M20.45 16.7l5.1 2.08",
    opacity: 0.72
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMonogram);
export default __webpack_public_path__ + "static/media/logo_monogram.17528bb2.svg";
export { ForwardRef as ReactComponent };